import { Injectable } from '@angular/core';
import { LocalStorageService } from '@ndk/ng-storage';

import { LocalStorageKeys } from '@core/storage/local-storage.enum';

@Injectable()
export class UrlLanguageReplaceService {
    constructor(
        private localStorageService: LocalStorageService) { }

    public replaceLanguage = (value: string): string => {
        return value.replace('[language]', this.getLanguage());
    }

    private getLanguage(): string {
        const language: string = this.localStorageService.getValue(LocalStorageKeys.CurrentLanguage);

        switch (language) {
            case 'pt-BR':
            case 'es-ES':
            case 'en-US':
                return language;
            default:
                return 'en-US';
        }
    }
}
